export const apiRequest = async (
  url: string,
  method: string,
  bodyParams?: any
): Promise<any> => {
  const response = await fetch(url, {
    method,
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json',
      'x-api-key': '8R@nDM0@p!',
    },
    body: bodyParams ? bodyParams : undefined
  })
  if (response) {
    if (!response.ok) {
      return { error: await response.clone().text() || 'Internal server error' }
    } else {
      if (method.toLowerCase() === 'delete') {
        return { response: 'success' };
      }
      return { response: await response.json() }
    }
  }
};
  